export default class Ux {
  constructor() {
    this.searchBy = {
      client: 0,
      account: 0,
    };

    this.changed = {
      client: false,
    };

    this.globalAdvLoader = {
      type: null,
      propsData: {},
      loading: false,
    };
  }
}
